module.exports = __webpack_public_path__ + "static/media/smGreenCheckCircle.d1a8f5c9.svg";